import { createAction, props } from '@ngrx/store';
export const setFundChartStartDate = createAction('[Fund Chart] Set start date', props());
